import React, { useState, useEffect } from "react";
import { CartProduct } from "../../assets/icons/icons";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";

const API_BASE = "https://laravel-api.aj-mart.com";
const STORAGE_BASE = `${API_BASE}/storage/app/public/`;
const PLACEHOLDER =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='800' height='600'><rect width='100%' height='100%' fill='%23f3f4f6'/><text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' fill='%239ca3af' font-size='20'>No Image</text></svg>";

const safeStr = (v) => (typeof v === "string" ? v : v == null ? "" : String(v));
const toNum = (v, fallback = 0) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
};
const splitDesc = (text, lang) => {
  const s = safeStr(text).trim();
  if (!s) return [];
  // عربي: قص على الفواصل أو الشرطات أو السطور
  if (lang === "ar") return s.split(/[|،؛•\-–—]+|\r?\n/).map((x) => x.trim()).filter(Boolean);
  // إنجليزي: أسطر أو فواصل/شرطات
  return s.split(/\r?\n|[|•\-–—]+/).map((x) => x.trim()).filter(Boolean);
};

export default function BrandsProducts() {
  const { t, i18n } = useTranslation();
  const [dataProduct, setDataProduct] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [brands, setBrands] = useState("");

  useEffect(() => {
    const pathParts = window.location.pathname.split("/");
    const lastPart = pathParts[pathParts.length - 1];
    setBrands(lastPart);
  }, []);

  useEffect(() => {
    if (!brands) return;

    const fetchData = async () => {
      try {
        const { data } = await axios.get(`${API_BASE}/api/products`, {
          withCredentials: true,
        });
        const list = Array.isArray(data?.products) ? data.products : [];
        const filtered = list.filter(
          (p) => safeStr(p?.product_brand_name) === brands
        );
        setDataProduct(filtered);
      } catch (error) {
        console.error("Error when fetching data:", error);
        setDataProduct([]);
      }
    };

    fetchData();
  }, [brands]);

  const getLocalizedText = (obj) => {
    // يرجّع النص المناسب للغة مع fallback فاضي بدل null
    return i18n.language === "ar" ? safeStr(obj.A) : safeStr(obj.E);
  };

  return (
    <>
      <section className="landingPages">
        <div className="container h-full flex flex-col gap-[10px] justify-center">
          <div className="text-[35px] font-bold text-white">{t("All Products")}</div>
          <div className="flex items-center gap-[3px] text-white">
            <Link to={"/"}>{t("Home")}</Link>
            <span>-</span>
            <div>{brands || t("All Products")}</div>
          </div>
        </div>
      </section>

      <section className="relative py-[40px]">
        <div className="container f-col flex justify-between gap-[50px]">
          <div className="w-100 w-[100%] flex flex-col justify-between gap-10">
            <div className="g-10 w-[100%] flex flex-wrap gap-[20px] just-center">
              {dataProduct.length > 0 ? (
                dataProduct.map((el, index) => {
                  const lang = i18n.language;
                  const productName = getLocalizedText({
                    A: el?.product_name_A,
                    E: el?.product_name_E,
                  });
                  const productDesc = getLocalizedText({
                    A: el?.product_desc_A,
                    E: el?.product_desc_E,
                  });
                  const descItems = splitDesc(productDesc, lang).slice(0, 2);

                  const price = toNum(el?.product_price, 0);
                  const discountPct = Math.max(0, toNum(el?.product_price_discount, 0));
                  const priceAfterDiscount = (price * (1 - discountPct / 100)).toFixed(2);

                  const inventoryClass =
                    toNum(el?.product_stock_available, 0) === 0
                      ? "text-red-500"
                      : "text-[#18AB00]";

                  const isHovered = hoveredIndex === index;
                  const imgSrc = safeStr(el?.product_main_img)
                    ? `${STORAGE_BASE}${safeStr(el.product_main_img).replace(/^\/+/, "")}`
                    : PLACEHOLDER;

                  return (
                    <div
                      key={el?.product_id ?? index}
                      className="pr-grid cursor-pointer flex flex-col w-[250px] h-[416px] rounded-md shadow-md outline outline-[2px] outline-solid relative"
                      style={{ outlineColor: "#eee" }}
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                    >
                      <Link to={`/productdetails/${el?.product_id ?? ""}`}>
                        <div className="h-[218px] w-full relative">
                          <img
                            className="w-full h-full rounded-t-md object-cover"
                            src={imgSrc}
                            alt={safeStr(el?.product_name_E) || "product"}
                            onError={(e) => (e.currentTarget.src = PLACEHOLDER)}
                          />
                          {discountPct > 0 && (
                            <div className="dis-grid w-10 h-10 bg-[#1485a6] rounded-full text-white font-bold flex items-center justify-center absolute top-[10px] right-[10px]">
                              {discountPct.toFixed(0)}%
                            </div>
                          )}
                        </div>
                      </Link>

                      <div className="h-[2px] bg-[#666666]"></div>

                      <div className="py-[10px] flex flex-col gap-[10px] p-4 pb-5">
                        <div className="flex items-center justify-between">
                          <div className="name-grid text-[16px] font-bold">
                            {productName.length > 50
                              ? productName.substring(0, 50) + "..."
                              : productName}
                          </div>
                          <div className="new-grid w-[60px] h-[19px] bg-[#1485a6] text-white capitalize font-bold rounded-tr-[100px] rounded-bl-[100px] flex items-center justify-center text-[10px]">
                            {safeStr(el?.product_status)}
                          </div>
                        </div>

                        <ul className="text-[10px] text-[#666666] list-disc pl-[20px]">
                          {descItems.map((desc, idx) => (
                            <li key={idx} className="text-[10px]">
                              {desc.length > 75 ? desc.substring(0, 75) + "..." : desc}
                            </li>
                          ))}
                        </ul>

                        <div className="flex justify-between">
                          <div className="flex flex-col gap-[5px]">
                            <span className="font-bold font-12">
                              {priceAfterDiscount} <span>{t("JOD")}</span>
                            </span>
                            {discountPct > 0 && (
                              <span className="line-through text-red-500 font-12">
                                {price.toFixed(2)} <span>{t("JOD")}</span>
                              </span>
                            )}
                          </div>
                          <div
                            className={`font-bold capitalize text-[14px] ${inventoryClass}`}
                          >
                            {t("In stock:")} {toNum(el?.product_stock_available, 0)}
                          </div>
                        </div>
                      </div>

                      <div
                        className={`bg-[#1485a6] flex p-1.5 items-center justify-center gap-1.5 text-white font-bold rounded-tl-[20px] rounded-tr-[20px] absolute bottom-0 left-0 right-0 transition-opacity duration-300 ${
                          isHovered ? "opacity-100" : "opacity-0"
                        }`}
                      >
                        <CartProduct />
                        <Link to={`/productdetails/${el?.product_id ?? ""}`}>
                          {t("Add To Cart")}
                        </Link>
                      </div>
                    </div>
                  );
                })
              ) : (
                <p className="text-gray-500 w-full text-center">
                  {t("No products found")}
                </p>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
